import _defineProperty from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/*
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { useState, useEffect } from 'react';
var unsupported;

var useNetworkStatus = function useNetworkStatus(initialEffectiveConnectionType) {
  if (typeof navigator !== 'undefined' && 'connection' in navigator && 'effectiveType' in navigator.connection) {
    unsupported = false;
  } else {
    unsupported = true;
  }

  var initialNetworkStatus = {
    unsupported: unsupported,
    effectiveConnectionType: unsupported ? initialEffectiveConnectionType : navigator.connection.effectiveType
  };

  var _useState = useState(initialNetworkStatus),
      _useState2 = _slicedToArray(_useState, 2),
      networkStatus = _useState2[0],
      setNetworkStatus = _useState2[1];

  useEffect(function () {
    if (!unsupported) {
      var navigatorConnection = navigator.connection;

      var updateECTStatus = function updateECTStatus() {
        setNetworkStatus({
          effectiveConnectionType: navigatorConnection.effectiveType
        });
      };

      navigatorConnection.addEventListener('change', updateECTStatus);
      return function () {
        navigatorConnection.removeEventListener('change', updateECTStatus);
      };
    }
  }, []);
  return _objectSpread(_objectSpread({}, networkStatus), {}, {
    setNetworkStatus: setNetworkStatus
  });
};

export { useNetworkStatus };